/**
 * @module PlatformSettingsPage
 * @purpose Platform-admin-only settings page (`/admin/platform`): the Demo Mode card
 *   (spec FR13, absent -- not disabled -- outside dev/demo) and the platform event log.
 * @depends contexts/demo-mode-context, pages/platform-settings/{DemoModeCard,PlatformEventLog}
 * @dependedOnBy app/AppRoutes.parts (wrapped in PlatformAdminRoute)
 *
 * @rules
 * - Performance: reads status from the shared DemoModeContext -- no own fetch
 * - State: none -- delegated to child cards
 * - Errors: delegated to child cards
 */

import { useTranslation } from 'react-i18next'
import { DemoModeCard } from './platform-settings/DemoModeCard'
import { PlatformEventLog } from './platform-settings/PlatformEventLog'

const TITLE_STYLE: React.CSSProperties = {
  fontFamily: 'var(--font-display)',
  fontSize: '1.5rem',
  fontWeight: 700,
  color: 'var(--text)',
}

const DESCRIPTION_STYLE: React.CSSProperties = {
  fontFamily: 'var(--font-body)',
  fontSize: '0.9rem',
  color: 'var(--text-dim)',
  marginTop: '4px',
}

/**
 * Platform admin settings page.
 *
 * @behaviour Renders the page header, the Demo Mode card (which decides its own
 *            visibility per environment), and the platform event log.
 * @errors n/a -- delegated to child components
 */
export function PlatformSettingsPage(): React.ReactElement {
  const { t } = useTranslation('admin')

  return (
    <div className="space-y-6">
      <div>
        <h1 style={TITLE_STYLE}>{t('platformSettings.title')}</h1>
        <p style={DESCRIPTION_STYLE}>{t('platformSettings.description')}</p>
      </div>
      <DemoModeCard />
      <PlatformEventLog />
    </div>
  )
}
